import * as React from 'react';
import { Trans } from '@lingui/macro';
import { Stack } from '@oms/ui-stack';
import { Wrap } from '@oms/ui-wrap';
import {
  useDisclosure,
  DisclosureButton,
  DisclosureContent,
} from '@oms/ui-disclosure';
// import { RenderField } from '@oms/ui-field';
import { UseInstrumentChartReturn } from '@oms/components-instrument-chart';
// import { useSuggest } from '@oms/components-suggest';

import PeriodSelector from './PeriodSelector';
import InfoSelect from './InfoSelect';
import TechnicalIndicatorSelect from './TechnicalIndicatorSelect';
// import * as styles from './styles';
import { SELECTION, SELECTION_INTRADAY } from './constants';

/* eslint-disable jsx-a11y/label-has-for */

export interface FiltersProps {
  collapsableFilters: boolean;
  isLoggedIn: boolean;
  setSelection: (selection: SELECTION) => void;
  selection: string;
  addCompare: UseInstrumentChartReturn['addCompare'];
  additions: UseInstrumentChartReturn['additions'];
  addAddition: UseInstrumentChartReturn['addCompare'];
  removeAddition: UseInstrumentChartReturn['removeAddition'];
  addTechnicalIndicator: UseInstrumentChartReturn['addTechnicalIndicator'];
  expandButtonClassName?: string;
  searchGroup?: string;
}

export const Filters = ({
  collapsableFilters,
  expandButtonClassName,
  isLoggedIn,
  addCompare,
  setSelection,
  selection,
  additions,
  addAddition,
  removeAddition,
  addTechnicalIndicator,
}: FiltersProps) => {
  const disclosure = useDisclosure();
  // const Suggest = useSuggest();

  const renderFilters = () => {
    /* eslint-disable jsx-a11y/label-has-associated-control */
    return (
      <Wrap gap={4}>
        {/* <Stack flex="1 0 15rem">
          <RenderField
            as={Suggest}
            name="suggest"
            label={<Trans>Compare with company/ticker</Trans>}
            group={searchGroup}
            onChange={(suggestion: any) =>
              addCompare(`${suggestion.ITEM}.${suggestion.SECTOR}`)
            }
          />
        </Stack> */}
        <Stack flex="1  0 15rem">
          <PeriodSelector
            id="AnalysisChart__PeriodSelector"
            selection={selection}
            onSelect={({ value }: { value: any }) => setSelection(value)}
          />
          <InfoSelect
            additions={
              selection === SELECTION_INTRADAY
                ? { ...additions, candlestick: undefined }
                : additions
            }
            isLoggedIn={isLoggedIn}
            addAddition={addAddition}
            removeAddition={removeAddition}
            hideCandlestick={selection === SELECTION_INTRADAY}
          />
        </Stack>
        <Stack flex="1 0 15rem">
          <TechnicalIndicatorSelect
            addTechnicalIndicator={addTechnicalIndicator}
          />
        </Stack>
      </Wrap>
    );
  };

  if (!collapsableFilters) {
    return renderFilters();
  }

  return (
    <div>
      <DisclosureButton
        as="button"
        {...disclosure}
        type="button"
        className={expandButtonClassName}
        // css={styles.expandButton}
      >
        {disclosure.visible ? (
          <Trans>Hide filters</Trans>
        ) : (
          <Trans>Show filters</Trans>
        )}
      </DisclosureButton>
      <DisclosureContent {...disclosure}>{renderFilters()}</DisclosureContent>
    </div>
  );
};
